import { I4BCellType } from '../configurations/i4b-column-configuration';
import { I4bCellConcept } from '../enums/i4b-cell-concept.enum';
import { HeaderType } from '../models/i4b-column-header.model';
import { I4BButtonColumn } from './i4b-button.column';

export class I4BEscalationProtocolsButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.ESCALATION_PROTOCOLS,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          enableConditions: [],
          visibleConditions: [
            [
              { key: 'canUpdateProtocol', value: true },
              { key: 'canDeleteProtocol', value: true }
            ]
          ],
          singleActions: [
            {
              order: 0,
              key: 'edit',
              label: 'IOT_DICTIONARY.EDIT',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateProtocol', value: true }]]
            },
            {
              order: 0,
              key: 'configure',
              label: 'IOT_DICTIONARY.CONFIGURE',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateProtocol', value: true }]]
            },
            {
              order: 1,
              key: 'delete',
              label: 'IOT_DICTIONARY.DELETE',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canDeleteProtocol', value: true }]]
            }
          ]
        }
      },
      { order: 1000 }
    );
  }
}
